import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    wrapper: {
      width: "100%",
    },
    conversionCard: {
      backgroundColor: theme.card.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
    },
    conversionHeader: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
    conversionContent: {
      flex: 1,
    },
    bottomRow: {
      display: "flex",
      flexDirection: "row",
      gap: spacing.s,
      marginTop: spacing.s,
    },
    halfCard: {
      flex: 1,
      backgroundColor: theme.card.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
    },
    label: {
      fontSize: 12,
      fontWeight: 500,
      margin: 0,
    },
    value: {
      fontSize: 22,
      fontWeight: 600,
      margin: 0,
    },
    halfCardValue: {
      fontSize: 14,
      fontWeight: 500,
      margin: 0,
    },
    subtitle: {
      fontSize: 12,
      fontWeight: 500,
      color: theme.text.tertiary,
      margin: 0,
    },
    dateText: {
      fontSize: 12,
      fontWeight: 500,
      color: theme.text.tertiary,
      margin: 0,
    },
  };

  return styles;
};
